import React from 'react';

import { Route, useRouteMatch } from 'react-router-dom';

import { PortalTabs } from '../config/portalConfig';
import ClassSessionsRoutes from './ClassSessions/ClassSessionsRoutes';
import ClassesRoutes from './Classes/ClassesRoutes';
import UsersRoutes from './AdminUsers/UsersRoutes';
import InsightsRoutes from './Insights/InsightsRoutes';
import TroubleshootingRoutes from './Troubleshooting/TroubleshootingRoutes';
import PlannerRoutes from './Planner/PlannerRoutes';
import SettingsRoutes from './Settings/SettingsRoutes';
import ProfileRoutes from './Profile/ProfileRoutes';
import FeedbackRoutes from './Feedback/FeedbackRoutes';
import DataRoutes from './Data/DataRoutes';
import SupportRoutes from './Support/SupportRoutes';
import AskTheAIRoutes from './AskTheAI/AskTheAIRoutes';
import HomeRoutes from './Home/HomeRoutes';

import { AddUsers } from './AdminUsers/AddUsers';

const PortalRoutes = () => {
    const { path } = useRouteMatch();
    console.log('PortalRoutes path', path);

    return (
        <>
            <Route path={`${path}${PortalTabs.Classes}`} component={ClassesRoutes} />
            <Route path={`${path}${PortalTabs.Users}`} component={UsersRoutes} />
            <Route path={`${path}${PortalTabs.Users}/add`} component={AddUsers} />
            <Route path={`${path}${PortalTabs.ClassSessions}`} component={ClassSessionsRoutes}/>
            <Route path={`${path}${PortalTabs.Insights}`} component={InsightsRoutes} />
            <Route path={`${path}${PortalTabs.Planner}`} component={PlannerRoutes} />
            <Route path={`${path}${PortalTabs.Settings}`} component={SettingsRoutes} />
            <Route path={`${path}${PortalTabs.Troubleshooting}`} component={TroubleshootingRoutes} />
            <Route path={`${path}${PortalTabs.Profile}`} component={ProfileRoutes} />
            <Route path={`${path}${PortalTabs.Feedback}`} component={FeedbackRoutes} />
            <Route path={`${path}${PortalTabs.Data}`} component={DataRoutes} />
            <Route path={`${path}${PortalTabs.Support}`} component={SupportRoutes} />
            <Route path={`${path}${PortalTabs.AskTheAI}`} component={AskTheAIRoutes} />
            <Route path={`${path}${PortalTabs.Home}`} component={HomeRoutes} />
        </>
    );
};

export default PortalRoutes;
